import { render } from "./CursoDestaque.vue?vue&type=template&id=a59409b6&scoped=true"
import script from "./CursoDestaque.vue?vue&type=script&lang=js"
export * from "./CursoDestaque.vue?vue&type=script&lang=js"

import "./CursoDestaque.vue?vue&type=style&index=0&id=a59409b6&lang=css"
import "./CursoDestaque.vue?vue&type=style&index=1&id=a59409b6&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a59409b6"]])

export default __exports__